import SearchWeather from './Components/SearchWeather';

function App() {
  return (
    <div className="App">
      <SearchWeather />
    </div>
  );
}

export default App;
